import { ComponentType, ReactElement, ReactNode } from "react";

export type DataProps<T> = {
  className?: string;
  data: T;
}

export type SkeletonableProps<T> = Omit<DataProps<T>, "data"> & {
  loading: boolean;
  data?: T;
}

export type WithTitle<T> = T & {
  title: string;
  subTitle?: string | ReactNode;
};

export const findComponentChild = <TChild extends ComponentType<any>>(children: ReactElement[], type: TChild)
  : ReactElement<any, ComponentType<TChild>> | undefined =>
  children.find(child => child.type === type) as ReactElement<any, TChild> | undefined;
